<template>
    
        <tr  v-if="!item.childs" >
                <td style=" font-size: 10px; height: 20px;">{{ item.id }}</td>
                <td colspan="4">
                    <template v-for="(permisoDepto,index) in item.PermisosDpto">
                     <tr  :key="index">
                        <td style="min-width:100px;">{{permisoDepto.deptoNombre}}</td>
                        <template v-for="(permiso,indexPerm) in permisoDepto.Permisos">
                            <td :key="indexPerm" style=" font-size: 10px; height: 20px; min-width:150px;"><v-checkbox  :label="permiso.Nombre" v-model="permiso.value" :value="true" style="margin-top: 0px; height: 25px;"></v-checkbox></td>
                        </template>
                     </tr> 
                    </template>
                </td>
                </tr>
        <tr v-else-if="item.childs" style="background: #2185d052;" >
            <td colspan="5">{{ item.title }}</td>
            

        </tr>
       <!-- <template v-if="item.childs" >
        <PermisosTableRow v-for="(it,idx) in item.childs"  :key="idx"  :item="it"></PermisosTableRow>
        </template>-->
          
           
      
   
</template>

<style scoped>
</style>


<script>

export default {
  name: "PermisosTableRow",
  components: {},
  props: ['item'],
  data() {
    return {
      selection: [],
     
    };
  },
  methods: {},
  computed: {},
  watch: {},
  beforeMount: function () {},
  mounted() {},
};
</script>